export default __webpack_public_path__ + "images/screenshot-search-2x-3d44261.png";